import { useAuth } from "@/contexts/AuthContext";
import { useState } from "react";
import AuthModal from "@/components/AuthModal";
import { Button } from "@/components/ui/button";
import UserMenu from "@/components/UserMenu";
import { UserMenuDropdown } from "@/components/UserMenuDropdown";
import { Link, useLocation } from "react-router-dom";
import { Star } from "lucide-react";
import { AlertsButton } from "@/components/alerts/AlertsButton";
import clsx from "clsx";
import { useIsMobile } from "@/hooks/use-mobile";
import { useNavigate } from "react-router-dom";
import { RegisteredUsersBanner } from "@/components/RegisteredUsersBanner";

interface Props {
  header: string;
}

export function MainLayoutMobileHeader({ header }: Props) {
  const { user } = useAuth();
  const [authMode, setAuthMode] = useState<"login" | "signup">("login");
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const onAuthClick = (mode: "login" | "signup") => {
    setAuthMode(mode);
    setIsAuthModalOpen(true);
  };

  const navigate = useNavigate();

  const onClickAlertsButton = () => {
    navigate("/notifications");
  };

  const isMobile = useIsMobile();

  return (
    <>
      <div className="container h-20 flex items-center justify-between lg:hidden gap-2">
        <h1 className="text-xl truncate flex-1">{header}</h1>
        <div className="flex items-center gap-2">
          {user && (
            <>
              <Button variant="ghost" size="icon" asChild>
                <Link to="/watchlist">
                  <Star />
                </Link>
              </Button>
              <AlertsButton
                className={clsx("dark:text-white", {
                  "text-white": !isMobile,
                  "text-black": isMobile,
                })}
                onClick={onClickAlertsButton}
              />
              <UserMenuDropdown onAuthClick={() => {}} />
            </>
          )}
          <div>
            {!user && (
              <Button onClick={() => onAuthClick("login")}>Sign In</Button>
            )}
            <AuthModal
              isOpen={isAuthModalOpen}
              onClose={() => setIsAuthModalOpen(false)}
              mode={authMode}
              onModeChange={setAuthMode}
            />
          </div>
        </div>
      </div>
      <div className={`${!isHomePage && "mb-4 lg:mb-12"}`}>
        <RegisteredUsersBanner />
      </div>
    </>
  );
}
